/**
 * Which sound question a reopened order's sounds go back to.
 *
 * An order stores its sounds as one list in play order, without the question
 * they were picked in, and a product may ask two (its own and a Sound
 * add-on). Handing the list to every sound question doubled it: the order
 * editor saved twice the sounds, and an edit from the cart would have too.
 * The answers say which question was used — a sound question's answer is the
 * line its card showed — so the sounds go back there, and the others start
 * empty. None answered (an older order): the first sound question.
 */

const SOUND_TYPES = new Set(['audio_source', 'voice_record', 'video_source']);

export function restoredSoundOption(
  options: ReadonlyArray<{ id: string; type: string }>,
  values: Record<string, unknown>,
): string | undefined {
  const sounds = options.filter((option) => SOUND_TYPES.has(option.type));
  if (sounds.length === 0) return undefined;
  const answered = sounds.find((option) => {
    const value = values[option.id];
    return value !== undefined && value !== null && value !== '' && !(Array.isArray(value) && value.length === 0);
  });
  return (answered ?? sounds[0]!).id;
}
